import { render, staticRenderFns } from "./loaderComponent.vue?vue&type=template&id=6debce4e&scoped=true"
var script = {}
import style0 from "./loaderComponent.vue?vue&type=style&index=0&id=6debce4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6debce4e",
  null
  
)

export default component.exports